<template>
  <b-input :value="value" @input="$emit('input', $event)" ref="input" :state="state" :maxlength="maxlength"/>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],

  props: {
    maxlength: { type: Number },
  }
}
</script>
